// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"H2-z","sponsoredTooltipWrapper":"I2-z","sponsoredTooltip":"J2-z","newCard":"K2-z"};